/**
 * organisations.service.ts — Layer 3: Organisations Domain
 */

import { getRequest, postRequest, putRequest, deleteRequest, postFormData } from './http.service';
import {
  URL_ORGANISATIONS,
  URL_ORGANISATIONS_LIST,
  URL_ORGANISATION_BY_ID,
  URL_ORG_STORAGE_PROVIDER,
  URL_INFO_APP_CONFIG,
  URL_PRIVACY_POLICY,
  URL_TERMS_OF_SERVICE,
  URL_ORGANISATION_PROFILE,
  URL_ORGANISATION_LOGO,
  URL_AGENT_MODEL_OPTIONS,
  URL_AGENT_MODEL_CATALOGUE,
  URL_AGENT_MODEL_PROVIDER,
  URL_AGENT_MODEL_SETTINGS,
} from './url.service';

export const fetchOrganisations = () =>
  getRequest(URL_ORGANISATIONS_LIST);

export const fetchOrganisationById = (orgId: string) =>
  getRequest(URL_ORGANISATION_BY_ID(orgId));

/** Get app-wide config (feature flags, branding, etc.) */
export const fetchAppConfig = () =>
  getRequest(URL_INFO_APP_CONFIG);

/** Get the public privacy policy document (markdown) */
export const fetchPrivacyPolicy = () =>
  getRequest(URL_PRIVACY_POLICY);

/** Get the public terms of service document (markdown) */
export const fetchTermsOfService = () =>
  getRequest(URL_TERMS_OF_SERVICE);

export const createOrganisation = (payload: Record<string, unknown>) =>
  postRequest(URL_ORGANISATIONS, payload);

export const updateOrganisation = (orgId: string, payload: Record<string, unknown>) =>
  putRequest(URL_ORGANISATION_BY_ID(orgId), payload);

export const deleteOrganisation = (orgId: string) =>
  deleteRequest(URL_ORGANISATION_BY_ID(orgId));

export const updateStorageProvider = (orgId: string, targetProvider: string) =>
  putRequest(URL_ORG_STORAGE_PROVIDER(orgId), { targetProvider });

/** Get the extended organisation profile (branding, contact info, etc.) */
export const fetchOrganisationProfile = (orgId: string) =>
  getRequest(URL_ORGANISATION_PROFILE(orgId));

/** Upload/replace the organisation's logo */
export const uploadOrganisationLogo = (orgId: string, formData: FormData) =>
  postFormData(URL_ORGANISATION_LOGO(orgId), formData);

/** Delete the organisation's logo */
export const deleteOrganisationLogo = (orgId: string) =>
  deleteRequest(URL_ORGANISATION_LOGO(orgId));

export const fetchAgentModelOptions = () =>
  getRequest(URL_AGENT_MODEL_OPTIONS);

export const fetchAgentModelCatalogue = () =>
  getRequest(URL_AGENT_MODEL_CATALOGUE);

export const updateAgentModelProvider = (provider: string, payload: Record<string, unknown>) =>
  putRequest(URL_AGENT_MODEL_PROVIDER(provider), payload);

export const fetchAgentModelSettings = (orgId: string) =>
  getRequest(URL_AGENT_MODEL_SETTINGS(orgId));

export const updateAgentModelSettings = (orgId: string, payload: Record<string, unknown>) =>
  putRequest(URL_AGENT_MODEL_SETTINGS(orgId), payload);
